export default __webpack_public_path__ + "static/char-s-21-zh-Hant-963560fbb61f5b9e0a3c659da5c197f4.webp";